// 常见问题
<template>
  <div class="cjwt width1200" role="tablist">
    <div class="item">
      <p class="title">动态HTTP代理隧道常见问题</p>
      <div class="item-list">
        <div class="collapse-ans">
          本页面提供关于动态HTTP代理隧道的一些常见问题的解答，如果您在使用过程中遇到问题，可以参阅。此外，您也可以在相关技术支持群里寻求帮助。
        </div>
      </div>
    </div>
    <div class="item" v-for="(item, index) in cjwtList" :key="index">
      <p class="title">{{ item.title }}</p>
      <div class="item-list">
        <div
          v-for="(accordion, accordionIndex) in item.data"
          :key="accordionIndex"
        >
          <div
            class="collapse-title d-flex d-flex-aic d-flex-jc-sb"
            :class="tabs == `${index}-${accordionIndex}` ? 'active' : ''"
            @click="collapseChange(index, accordionIndex)"
          >
            <span>{{ accordion.req }}</span>
            <img
              :src="
                require(tabs == `${index}-${accordionIndex}`
                  ? '@/assets/images/icon12.png'
                  : '@/assets/images/icon11.png')
              "
              alt=""
            />
          </div>
          <div
            class="collapse-ans"
            :style="{
              display: tabs == `${index}-${accordionIndex}` ? 'block' : 'none',
            }"
          >
            {{ accordion.ans }}
            <!--{{ (tabs, `${index}-${accordionIndex}`) }}-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabs: "0-0",
      cjwtList: [
        {
          title: "功能相关问题",
          data: [
            {
              req: "支持什么协议，都是高匿代理吗？",
              ans: "同时支持HTTP/HTTPS协议，所有代理IP均是高匿。",
            },
            {
              req: "每秒请求数是？",
              ans: "一秒内发起的所有请求数之和，如果超出套餐限制的值，那么多出的部分会被拒绝访问（提示429 Too many requests!），这时候需要购买更多的请求数以满足业务需求。注意，这里是指每秒允许发起的请求数总和，不是并发数，也不是说一秒内对应数量的请求能全部返回结果",
            },
            {
              req: "带宽是独享的吗？",
              ans: "是的，确保每个账号所分配的带宽都是独享的。默认每20个请求数配1Mbps带宽",
            },
            {
              req: "支持大文件下载吗？",
              ans: "HTTP隧道代理不适用于大文件下载的场景，建议使用用API代理",
            },
            {
              req: "每天使用的IP数量有限制吗？",
              ans: "没有，池子里面有多少IP您就能使用多少IP，不会人为限制所能使用的IP的数量",
            },
            {
              req: "支持keep-alive吗？",
              ans: "套餐3不支持，其他套餐都支持，但是需要注意的是，每次切换IP之前或者IP即将到期时，需要断开当前tcp连接，等切换IP完毕之后再创建新的tcp连接，否则会导致持续出现失败的请求",
            },
          ],
        },
        {
          title: "IP池相关问题",
          data: [
            {
              req: "池子里的代理IP都是在网上采集的免费代理吗？",
              ans: "不是的，多贝云所有的动态IP的来源都是基于运营商的家庭宽带线路自建的，我们会在全国各地拉ADSL线路进入到IDC机房，再通过专用网络设备接入到平台",
            },
            {
              req: "总池子多少IP？",
              ans: "目前池子里面总共有150万的IP，并且每周都会进行优化调整",
            },
            {
              req: "地区分布如何？",
              ans: "分布在全国24个省份直辖市，上百个城市节点，并且持续在增加",
            },
          ],
        },
        {
          title: "购买相关问题",
          data: [
            {
              req: "带宽或者每秒请求数能够在默认套餐基础上额外增加吗？",
              ans: "可以，需要支付升级费用",
            },
            {
              req: "可以免费测试吗？",
              ans: "可以，请联系商务人员",
            },
            {
              req: "是否可以开具发票？",
              ans: "可以，消费累计达到2000元或以上即可",
            },
            {
              req: "是否可以签订合同？",
              ans: "可以",
            },
          ],
        },
      ],
    };
  },
  methods: {
    collapseChange(index, accordionIndex) {
      this.tabs = `${index}-${accordionIndex}`;
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/cjwt.less";
</style>
